export default __webpack_public_path__ + "static/media/place5.1fa403ae.jpg";